import anime from 'animejs';
import barba from '@barba/core';

import { addFinishesListeners, removeFinishesListeners } from './app';
import { addSliders } from './render-carousels';

const newPageCallback = () => {
  addFinishesListeners();
  addSliders();
}

// sample Barba config (consider moving to its own partial in larger projects)
const defaultTransition = {
  // Leave hook with destructured `data.current`
  leave({ current }) {
    removeFinishesListeners();

      // Create your tween
      const t = anime({
          // [data-barba="container"] of current page
          targets: current.container,
          duration: 300,
          opacity: [1, 0],
          easing: 'linear'
      });

      // Return a promise
      return t.finished;
  },
  // Leave hook with destructured `data.next`
  enter({ next, trigger }) {
    if (trigger !== 'back' && trigger !== 'forward') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      }); // scroll to top of page
  }
      // Create your tween
      const t = anime({
          // [data-barba="container"] of next page
          targets: next.container,
          duration: 300,
          opacity: [0, 1],
          complete: newPageCallback
      });
  }
};
// Init barba.js with your transition.
barba.init({
  transitions: [defaultTransition]
});